<template>
    <div v-if="modal.backdrop">
        <div
            class="modal fade"
            :class="modal.open ? 'show' : ''"
            style="display: block"
            tabindex="-1"
            role="dialog"
            @click="$event.target.classList.contains('modal') ? close() : true"
        >
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"> Filter Realisasi Kunjungan Sales</h5>
                        <button type="button" class="close" @click="close()" v-html="modal.loading ? spin() : ic('close')"/>
                    </div>
                    <form v-on:submit.prevent="submit">
                        <div class="modal-body default">
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label class="form-label" for="tim">Salesman</label>
                                    <selectize
                                        id="salesman"
                                        data-placeholder="Pilih Salesman"
                                        :settings="modal.selectizeConfig"
                                        v-model="filter.ids_tim"
                                        :disabled="modal.loading"
                                    >
                                        <option
                                            :value="salesman.id_tim"
                                            v-for="(salesman, index) in selectOption.list_salesman"
                                            :key="index"
                                        >
                                            {{ `${salesman.nama_salesman} (${salesman.tim})` }}
                                        </option>
                                    </selectize>
                                </div>

                                <div class="col-12 form-group">
                                    <label for="tanggal" class="form-label">Tanggal</label>
                                    <input
                                        id="tanggal"
                                        type="date"
                                        class="form-control"
                                        v-model="filter.tanggal"
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-white"
                                @click="close"
                                v-html="'Tutup'">
                            </button>
                            <button
                                type="submit"
                                class="btn btn-primary"
                                :disabled="modal.loading"
                                v-html="'OK'">
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import { mapActions } from "vuex";

const now = new Date();
export default {
    name: "FilterServiceLevelSalesMT",
    props:{
        isOpen: false
    },
    mixins: [helper],
    data(){
        return {
            // config init varibale modal
            modal:{
                open: false, 
                backdrop: false,
                loading: false,
                selectizeConfig: {
                    maxItems: 99,
                    plugins: ["remove_button"],
                },
            },
            selectOption: {
                list_salesman: [],
            },
            filter:{
                ids_tim: [],
                tanggal: this.dateTime("ymd"),
            }
        }
    },
    methods: {
        ...mapActions('salesman', ['getListSalesman']),

        async _getSalesman(){
            try {
                this.modal.loading = true
                this.selectOption.list_salesman = await this.getListSalesman()
            } catch (error) {
                console.log(error)
            }finally{
                this.modal.loading = false
            }
        },

        submit() {
            this.$emit("submit", this.filter);
            this.close();
        },

        close() {
            this.$emit("update:isOpen", false);
        },
    },
    watch: {
        "isOpen": function(isOpen){
            if (isOpen) {
                this.modal.backdrop = isOpen;
                setTimeout(() => {
                    if(this.selectOption.list_salesman == 0) this._getSalesman()
                    this.modal.open = isOpen;
                }, 100);
            } else {
                this.modal.open = isOpen;
                setTimeout(() => {
                    this.modal.backdrop = isOpen;
                }, 100);
            }
        }
    }
}
</script>